import React from "react";
import style from "../components/SoftwareAddresses.module.css";
import { Form, FormCheck } from "react-bootstrap";
import AddressSelect from "../components/AddressSelect";

export default function SoftwareAddresses({
  DeliveryAddressId,
  InstallationAddressId,
  setDeliveryAddressId,
  setInstallationAddressId,
  sameAddress,
  setSameAddress,
  type
}) {
  return (
    <div className={style.root}>
      <Form.Group controlId={`${type}-deliveryAddress`}>
        <Form.Label>Delivery Address</Form.Label>
        <FormCheck type="checkbox" checked={sameAddress} label="Same Delivery and Installation Address" className={style.sameAddress}
          onChange={e => setSameAddress(e.target.checked) }
          />

        <Form.Control
          as={AddressSelect}
          addressId={DeliveryAddressId}
          onAddressIdChange={setDeliveryAddressId}
        />
      </Form.Group>

      {!sameAddress && 
      <Form.Group controlId="installationAddress">
        <Form.Label>Installation Address</Form.Label>

        <Form.Control
          as={AddressSelect}
          addressId={InstallationAddressId}
          onAddressIdChange={setInstallationAddressId}
        />
      </Form.Group>
      }
    </div>
  );
}